import { get } from 'svelte/store';
import { readDeviceStatus, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
import { format } from 'svelte-i18n';
import { capFirstChar } from 'src/helpers/utilities';
//Types
import type { ActionJob, LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';
import type { Device } from 'src/types/Device';
import type { SelectOptionPropsType } from '@Shelly/shelly-design-system/index';

export const getPresenceLocalActions = (
	action: ActionJob,
	device: Device,
	localControlOptions: LocalControlOptions[],
): LocalControlOptions[] => {
	const $format = get(format);
	localControlOptions = [
		{
			title: $format('label_control_zone', {
				default: 'Control Zone',
			}),
			value: 'presencezone.setconfig',
			attr: {
				target: getTargetOptions(device),
				config: {
					enable: true,
				},
			},
			params: {
				id: action.params?.id ?? 200,
				config: {
					enable: action.params?.config?.enable || false,
				},
			},
		},
	];
	return localControlOptions;
};

const getTargetOptions = (device: Device): SelectOptionPropsType[] => {
	const channelsOptions: SelectOptionPropsType[] = [];
	const deviceSettings = readDeviceSettings(device.id);
	Object.keys(deviceSettings).forEach((key) => {
		if (key.startsWith('presencezone:')) {
			channelsOptions.push({
				title: deviceSettings[key].name,
				value: deviceSettings[key].id,
			});
		}
	});
	return channelsOptions;
};

export const getPresenceComponents = (deviceSetting: any) => {
	const options = [];
	const components = Object.keys(deviceSetting)
		.filter((i) => /^(illuminance|presencezone):\d/.test(i))
		.sort();
	for (let i = 0; i < components.length; ++i) {
		const type = components[i].split(':')[0];
		const component = deviceSetting[components[i]];
		options.push({
			title: capFirstChar(component.name || `${type} (${component.id})`),
			type,
			component: components[i],
			inputType: type,
			cid: component.id,
		});
	}
	return options;
};
